import { Col, Row } from 'antd';
import React from 'react';

import {
    BORDER_LIGHT,
    BORDER_MAIN,
    CELL_HEIGHT,
    COUNT_HOURS,
    PARTS_IN_HOUR,
    WIDTH_COLUMN_CALENDAR_TIME,
} from '../const';
import { DayWeekType } from '../types';
import CalendarGridColumnWeek from './calendarGridColumnWeek';

interface ICalendarGrid {
    typeGrid: DayWeekType;
}

const CalendarGridDayWeek: React.FC<ICalendarGrid> = ({ typeGrid }) => {
    const countColumn = typeGrid === 'week' ? 7 : 1;

    const getContentDay = () => {
        return Array.from({ length: countColumn }).map((_, index) => {
            return (
                <div key={index}>
                    <div
                        style={{
                            borderBottom: BORDER_LIGHT,
                            backgroundColor: 'red',
                            marginTop: CELL_HEIGHT - 1,
                            marginLeft: -5,
                        }}
                    ></div>
                    <div
                        style={{
                            borderBottom: BORDER_MAIN,
                            backgroundColor: 'red',
                            marginTop: CELL_HEIGHT,
                            marginLeft: -5,
                        }}
                    ></div>
                </div>
            );
        });
    };

    return (
        <>
            {Array.from({ length: COUNT_HOURS }).map((_, index) => {
                return (
                    <Row key={index}>
                        <Col
                            style={{
                                borderRight: BORDER_MAIN,
                                width: WIDTH_COLUMN_CALENDAR_TIME,
                            }}
                        >
                            <label
                                style={{
                                    position: 'absolute',
                                    color: 'grey',
                                    fontSize: 10,
                                    right: 10,
                                    bottom: -7,
                                }}
                            >
                                {index > 11 ? index - 11 : index + 1} {index >= 11 ? 'PM' : 'AM'}
                            </label>
                        </Col>
                        <Col
                            style={{
                                width: `calc(100% - ${WIDTH_COLUMN_CALENDAR_TIME}px)`,
                                position: 'relative',
                            }}
                        >
                            {
                                <CalendarGridColumnWeek
                                    countColumn={countColumn}
                                    rowHeight={CELL_HEIGHT * PARTS_IN_HOUR}
                                    children={getContentDay()}
                                />
                            }
                        </Col>
                    </Row>
                );
            })}
        </>
    );
};

export default CalendarGridDayWeek;
